import React from 'react';
import type { FooterSliceProps } from '@ww-digital/web-palette-react/dist/components/Slice/FooterSlice/FooterSlice';

import { FooterSlice } from '@ww-digital/web-palette-react/dist/components/Slice/FooterSlice/FooterSlice';

interface FooterSliceContainerProps {
  slice: FooterSliceProps;
}

export const FooterSliceContainer = ({
  slice,
}: FooterSliceContainerProps): JSX.Element => {
  return <FooterSlice {...slice} />;
};
